import PropTypes from 'prop-types';
import React from 'react';
import Tabs from '@mui/material/Tabs';
import { injectIntl } from 'react-intl';

import StepTab from '../StepTab';

function a11yProps(index: any) {
  return {
    id: `phase-step-${index}`,
    'aria-controls': `phase-step-panel-${index}`,
  };
}

function DesktopStepTabs({ value, onChange, tabs, intl }: any) {
  return (
    <Tabs
      value={value}
      onChange={onChange}
      TabIndicatorProps={{ style: { display: 'none' } }}
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      aria-label={intl.formatMessage({ id: 'POSTS.STEPS.TABS.LABEL' })}
    >
      {tabs.map((tab: any, i: any) => (
        <StepTab
          key={i}
          state={tab.dates_status}
          stateLabel={tab.stateLabel}
          label={tab.label}
          selected={tab.selected}
          value={tab.value}
          wrapped
          {...a11yProps(i)}
        />
      ))}
    </Tabs>
  );
}

DesktopStepTabs.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      dates_status: PropTypes.string.isRequired,
      stateLabel: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.number.isRequired,
};

export default injectIntl(DesktopStepTabs);
